<div class="filters-box">
  <div class="flex-fill"></div>

  <div dropdown [isDisabled]="1 | isReadonlyRole" class="btn-group">
    <button
      dropdownToggle
      type="button"
      class="btn btn-secondary-warning dropdown-toggle"
      i18n-matTooltip
      matTooltip="You can perform multiple actions using this button."
    >
      <span class="cs-icon cs-icon-bolt"></span> <ng-container i18n>Actions</ng-container>
    </button>
    <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
      <li>
        <button (click)="onPushRatesSelected()" type="button" [disabled]="!isAnySelected()">
          <span class="fas fa-arrow-up"></span> <ng-container i18n>Push Rates</ng-container>
        </button>
      </li>
      <li>
        <button (click)="onDeleteSelected()" type="button" [disabled]="!isAnySelected()">
          <i class="cs-icon cs-icon-trash"></i> <ng-container i18n>Delete</ng-container>
        </button>
      </li>
    </ul>
  </div>
  <button type="button" [disabled]="1 | isReadonlyRole" class="btn btn-secondary-info" (click)="onAdd()">
    <span class="far fa-plus"></span> <ng-container i18n>Add Mapping</ng-container>
  </button>
</div>
<div class="table-holder table-responsive">
  <table class="table table-default table-striped">
    <mat-table #table matSort matSortActive="channelName" matSortDirection="asc" [dataSource]="dataSource">
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
          >
          </mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
          <mat-checkbox (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
          </mat-checkbox>
          <i
            *ngIf="!rateMapHasConnection(row)"
            i18n-matTooltip
            matTooltip="Rental is not linked to a channel, rate push will fail."
            matTooltipPosition="above"
            class="fal fa-exclamation-triangle ml-3"
          ></i>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="channelName">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Channel Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.channelName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="propertyId">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Property ID</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.propertyId }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="roomId">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Room ID</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.roomId }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="ratename">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Channel Category</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.ratename }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="category">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>AdvanceCM Category</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.category }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="created">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Date Mapped</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span [matTooltip]="element.created | epoch" matTooltipPosition="above">
            {{ element.created | epoch : 'DD - MMM - YYYY' }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="autosync">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          <span
            i18n-matTooltip
            matTooltip="When enabled AdvanceCM will automatically update your channel rates as your availability changes."
            matTooltipPosition="below"
          >
            <ng-container i18n>Auto Sync</ng-container> <i class="fas fa-info-circle"></i>
          </span>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
          <app-form-switch
            #slideToggle
            [disabled]="1 | isReadonlyRole"
            [checked]="!!element.autosync"
            [inline]="true"
            (valueChange)="onChangeSync(element)"
            [matTooltip]="
              element.autosync
                ? 'Synchronization is enabled for this rate mapping.'
                : 'Synchronization is disabled for rate mapping.'
            "
          >
          </app-form-switch>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef i18n>Edit</mat-header-cell>

        <mat-cell *matCellDef="let element">
          <div dropdown placement="bottom right" container="body" [isDisabled]="1 | isReadonlyRole">
            <div dropdownToggle (click)="$event.stopPropagation()" class="btn-group btn-ellips-holder">
              <a class="btn-ellips">
                <i class="fas fa-ellipsis-v"></i>
              </a>
            </div>
            <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
              <li>
                <button (click)="onEdit(element)" type="button">
                  <i class="fal fa-edit"></i> <ng-container i18n>Edit</ng-container>
                </button>
              </li>
              <li>
                <button (click)="onPushRate(element)" type="button">
                  <i class="fas fa-arrow-up"></i> <ng-container i18n>Push Rate</ng-container>
                </button>
              </li>
              <li>
                <button (click)="onDelete(element)" type="button">
                  <i class="cs-icon cs-icon-trash"></i><ng-container i18n>Delete</ng-container>
                </button>
              </li>
            </ul>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedColumns"
        [class.row-danger]="!rateMapHasConnection(row)"
        (click)="onEdit(row)"
      ></mat-row>
    </mat-table>

    <mat-paginator2
      #paginator
      [length]="dataSource?.data?.length"
      [class.hidden]="isEmptyTable$ | async"
      [pageSize]="20"
      [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
      [showFirstLastButtons]="true"
    >
    </mat-paginator2>

    <app-empty-table *ngIf="isEmptyTable$ | async" [type]="tableType" class="bg-white">
      <p>
        <ng-container i18n>Need advanced rate management? Try</ng-container>
        <a href="https://www.rategenie.io/" target="_blank">Rategenie</a>,
        <ng-container i18n>AdvanceCM's best-in-class dynamic pricing application.</ng-container>
      </p>
    </app-empty-table>
  </table>
</div>
